export const DdboxConstants = {
    class: ".mod_ddbox",
    delay: 8e3,
    closeButton: ".close",
    editorWrapper: "__editorTarget",
    visible: "is-visible",
    locked: "is-locked",
    coords: "coords",
    dataCoords: "data-coords",
    tooBig: "is-too-big",
    mobile: "mobile_client",
    desktop: "desktop_client",
    timerSelector: ".ddbox-timer-countdown"
}
